import { useBondsBondFieldApi } from '../api';

export const useBondsBondSMarketQtMin = () => {
  const response = useBondsBondFieldApi('S_MARKET.QT_MIN');
  return response;
};
